import { useState } from "react";
import Loading from "./loading";
import { Link, useNavigate } from "react-router-dom";

interface ModalProps {
  message: string; // Prop para el texto del placeholder
  titel: string;
  textButton: string;
  onClick: () => void; // Prop para la función
}

const ModalSearch = ({ message, titel, textButton, onClick }: ModalProps) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [number, setNumber] = useState("");
  const [borderEmail, serborderEmail] = useState(
    "w-full border border-gray-200 outline-none py-2 px-8 rounded-lg mb-3"
  );
  const onlyNumbersRegex = /^\d+$/;
  const navigate = useNavigate();
  const getData = () => {
    if (error || number === "") {
      return;
    }
    setLoading(true);
    console.log(number);
    fetch(`https://medicalcourrierapi.com/api/?id=${number}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Error en la respuesta");
        }
        return response.json();
      })
      .then((data) => {
        console.log(data);
        let dataR = { deliveries: data.deliveries[0], orders: data.orders[0] };
        console.log(dataR);
        toNavigate(dataR);
      })
      .catch((error) => {
        setLoading(false);
        console.error("Hubo un problema con la petición fetch:", error);
      });
  };

  const toNavigate = (dataR: any) => {
    setLoading(false);
    navigate("odSearch", { state: { dataR } });
  };
  return (
    <>
      {loading && <Loading />}
      <div className="fixed bottom-4 right-4 z-50">
        <div className="bg-white p-6 rounded-lg shadow-lg text-center w-80">
          <h2 className="text-2xl font-bold mb-4">Sigue tu envio</h2>
          <input
            type="number"
            className={borderEmail}
            placeholder="ingresa número de orden"
            id="number"
            name="number"
            onChange={(e) => {
              setNumber(e.target.value);
              console.log(onlyNumbersRegex.test(e.target.value));
              setError(!onlyNumbersRegex.test(e.target.value));
            }}
          />

          {error ? (
            <h3 className="mb-1 text-red-400">error en el número ingresado </h3>
          ) : (
            ""
          )}
          <button
            onClick={getData}
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
          >
            Buscar
          </button>
        </div>
      </div>
    </>
  );
};

export default ModalSearch;
